'use client';

import Image from 'next/image';
import useCheckIsMobileSize from '@/hooks/useCheckIsMobileSize';

const HeroSectionImage = () => {
  const baseImageUrl = process.env.NEXT_PUBLIC_BASE_IMAGE_URL;
  const isMobile = useCheckIsMobileSize();
  const heroImageSrc = isMobile ? `${baseImageUrl}/home/m-hero.png` : `${baseImageUrl}/home/pc-hero.png`;

  return <Image src={heroImageSrc} alt="리뷰웍스" width={1200} height={630} className="mt-[79px] md:mt-[77px] h-auto" priority fetchPriority="high" />;
};

export default HeroSectionImage;
